import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/fyrmai.webp';
import screenshot_target from '../../../images/letterfunnel/rachiddegraaff.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Rachid de Graaff"
      firstname="Rachid"
      companyname="Fyrm.ai"
      competition="RockingData en Xebia"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/rachiddegraaff.js